@use "../../styles/text";

:host {
  display: block;
  border: 0;
  color: var(--color-text-base);
  margin: 0;
  padding: 0;
  > .hp-heading {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
  }
}

:host([size-selection="xxs"]) > .hp-heading {
  @include text.text-heading-xxs;
}

:host([size-selection="xs"]) > .hp-heading {
  @include text.text-heading-xs;
}

:host([size-selection="sm"]) > .hp-heading {
  @include text.text-heading-sm;
}

:host([size-selection="md"]) > .hp-heading {
  @include text.text-heading-md;
}

:host([size-selection="lg"]) > .hp-heading {
  @include text.text-heading-lg;
}

:host([size-selection="xl"]) > .hp-heading {
  @include text.text-heading-xl;
}

:host([size-selection="xxl"]) > .hp-heading {
  @include text.text-heading-xxl;
}
